import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Paper, Box } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import initialState from '@/state/wallets/slices/initial-state'

import {
  WalletsGeneralTableComponent,
  WalletsFilters,
  WalletsFormDialog,
  UiFeedbackWalletComponent,
} from './components'

import { useWalletsFilters, useWalletsActions } from './hooks'

const WalletsModule = () => {
  const { handleChangeLimit, handleChangePage } = useWalletsFilters()

  const { setWalletsFilters, getAllWallets } = useWalletsActions()

  const { brand } = useSelector(({ auth }: ApplicationState) => auth)

  useEffect(() => {
    setWalletsFilters(initialState.filters)
    getAllWallets(initialState.filters)
  }, [brand]) // eslint-disable-line

  return (
    <Box
      component={Paper}
      minHeight="calc(100vh - 168px)"
      display="flex"
      flexDirection="column"
      borderRadius={2}
    >
      <Box p={2}>
        <WalletsFilters />
      </Box>
      <WalletsGeneralTableComponent
        handleChangeLimit={handleChangeLimit}
        handleChangePage={handleChangePage}
      />
      <UiFeedbackWalletComponent />
      <WalletsFormDialog />
    </Box>
  )
}

export default WalletsModule
